<div class="warning-banner">
  <div class="icon">
    <mat-icon>info</mat-icon>
  </div>
  <div class="warning-description">
    <ng-content></ng-content>
  </div>
</div>
